import * as d3 from 'd3'
export default {
  methods: {

   draw_DataGroup() {

      let tbl = this.table
      
      let table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.header.y + this.header.height})`)

      let y_ = 12
      this.tblData.forEach((d,i)=> {

        this.columns.forEach((col,c)=> {
          if(c>2) return 
          
          let alpha = 1+col.tSize*0.26
          
          // Merge
          if(c<2 && (this.tblData[i-1]) && this.tblData[i][col.code] == this.tblData[i-1][col.code]) return

          if(c==0 && this.tblData[i+1]) {
            table
            .append('g')
            .attr('id', `WRAP_${i}_${c}_${this.localId}`)
            .attr('transform', `translate(${col.mx}, ${y_})`)

            this.gmx_wrapText(
              {
                text: d[col.code],
                wSize: col.wrap, // Wrap Width
                lineHeight: 13,
                parents: `#WRAP_${i}_${c}_${this.localId}`, 
                tColor: '#000', 
                tSize: 10.5, 
                align: 'middle',
              },
            )
          } 

          if(d.group == 'GRAND' && c==2) {
            table
            .append('rect')
            .attr('x', 0).attr('y', y_-10)
            .attr('width', tbl.width).attr('height', 20)
            .attr('fill', '#E0E0DF')

            let x_ = (this.columns[0].width + this.columns[1].width + this.columns[2].width)/2
            this.gmx_Text(table, '', x_,  y_+alpha, d.tSize, d.tColor, 'middle', '', 'GRAND TOTAL')
          } 
          
          if(d.group == 'SUB' && c==1) {
            table
            .append('rect')
            .attr('x', col.sx).attr('y', y_-10)
            .attr('width', tbl.width - col.sx).attr('height', 20)
            .attr('fill', '#ECECEC')

            this.gmx_Text(table, '', col.ex,  y_+alpha, d.tSize, d.tColor, 'middle', '', d[this.table.group[0]])

            table
            .append('line')
            .attr('x1', 0).attr('y1', y_+10)
            .attr('x2', tbl.width).attr('y2', y_+10)
            .attr('stroke', '#E0E0DF').attr('stroke-width', .5).attr('opacity', 1)
          }


          if(d.group=='TOTAL' && c==2) {
            table
            .append('rect')
            .attr('x', col.sx).attr('y', y_-10)
            .attr('width', tbl.width - col.sx).attr('height', 20)
            .attr('fill', '#F4F5F5')

            this.gmx_Text(table, '', col.mx,  y_+alpha, d.tSize, d.tColor, 'middle', '', 'TOTAL')

            table
            .append('line')
            .attr('x1', this.columns[0].ex).attr('y1', y_+10)
            .attr('x2', tbl.width).attr('y2', y_+10)
            .attr('stroke', '#E0E0DF').attr('stroke-width', .5).attr('opacity', 1)
          }


          if(!d.group && c>0) this.gmx_Text(table, '', col.mx,  y_+alpha, d.tSize, d.tColor, 'middle', '', d[col.code])

        })

        y_ = y_ + tbl.lineHeight
      })



    },


  }
}